export enum HttpMethod {
  GET = "GET",
  POST = "POST",
  PATCH = "PATCH",
  DELETE = "DELETE",
  PUT = "PUT",
  OPTIONS = "OPTIONS",
}

/**
 * The specific response codes handlers throw with, kept separate from the
 * range boundaries above so a status is spelled out at the throw site instead
 * of appearing as a bare number.
 */
export enum HttpStatus {
  BadRequest = 400,
  Unauthorized = 401,
  Forbidden = 403,
  NotFound = 404,
  MethodNotAllowed = 405,
  Conflict = 409,
  InternalServerError = 500,
}
/**
 * Test-only request header. When present, the server uses the supplied
 * `CreatedModified` id for the request instead of creating a fresh one, which
 * lets tests plant records whose created date is in the past. Ignored in
 * production — see `getServerCreateModifiedId`.
 *
 * Lower-cased like the `mocksetting_<setting_name>` header `getSettingBLL`
 * reads, because Node lower-cases incoming header names.
 */
export const TEST_CREATE_MODIFIED_ID_HEADER = "test_create_modified_id";
